






import { Component } from 'nuxt-property-decorator'
import HorizontalScroll from './horizontal-scroll.vue'
import TourBusinessBase from '~/components/tour/tour-base/business-base'
import commonSectionStructure from '~/components/tour/section-list/common/base.vue'

@Component({
  components: {
    HorizontalScroll,
    commonSectionStructure
  }
})
export default class TourAdSectionMobile extends TourBusinessBase {
  static displayName = 'MobileExperienceTour_advertising'

  get imgList() {
    return this.businessData?.list || []
  }
}
